import SharedSkinUtils from '../../../../../shared/SkinUtils';

SkinUtils.$inject = ['SharedModuleService'];

export default function SkinUtils(SharedModuleService) {
    return SharedModuleService.createFactory(SharedSkinUtils);
}
